module.exports = __webpack_public_path__ + "static/media/ICICIBANK.ef5dfdee.txt";